module.exports = __webpack_public_path__ + "static/online-program-02-f67fe06f16b558ea043493b712356165.jpg";